<template>
  <svg viewBox="0 0 7 8" xmlns="http://www.w3.org/2000/svg">
    <rect y="7.5" width="7" height="7" rx="3.5" transform="rotate(-90 0 7.5)"/>
  </svg>
</template>

<style scoped lang="scss">
svg {
  width: 7px;
  height: 8px;
}
</style>